module.exports = __webpack_public_path__ + "static/media/herobackground.c148fdaa.jpg";